module.exports = __webpack_public_path__ + "static/media/question-active.ac545a0d.svg";